export default __webpack_public_path__ + "static/media/151-maps-and-flags-6.15b38175.png";